import COMMON from '../class/common';

const [d] = [document];

export default class CUSTOMIZE extends COMMON {


}
